import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GoogleSheetUploadFacade } from '@mode/dataset/google/contract';
import { UploadSheetDialogService } from './upload-sheet-dialog/upload-sheet-dialog.service';
import { UploadSheetService } from './upload-sheet/upload-sheet.service';

@NgModule({
  imports: [CommonModule],
  providers: [UploadSheetDialogService, { provide: GoogleSheetUploadFacade, useClass: UploadSheetService }],
})
export class DatasetGoogleFeatureDialogModule {}
